import { Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { SettingStoreConst } from '@/common/store/setting.store';
import { SortStoreConst } from '@/tsort/store/sort.store';
import { GetTaskResponse } from '@/tsort/model/response/get-task-response.model';
import { ScanConfirmField } from '@/tsort/model/scan-confirm-field.model';
import SettingService from '@/common/service/setting.service';
import SortingService from '@/tsort/service/sorting.service';
import { MstDeviceType } from '@/common/enum/mst-device-type.enum';
import { SortModalType } from '@/tsort/enum/sort-modal-type.enum';
import { TaskTypeSorting } from '@/tsort/enum/task-type-sorting.enum';
import { WorkInstruction } from '@/tsort/enum/work-instruction.enum';
import { WorkTypeSorting } from '@/tsort/enum/work-type-sorting.enum';
import { ScanSystemField } from '@/tsort/model/response/scan-system-field.model';
import { ScanSystemSetting } from '@/tsort/model/response/scan-system-setting.model';
import SwipeButton from '@/common/components/swipe-button/swipe-button';
import SortingUtils from '@/common/utils/sorting.util';
import ConfigUtils from '@/common/utils/config.util';
import { ScanMode } from '@/common/enum/scan-mode.enum';
import { ChuteModeType } from '@/tsort/enum/chute-mode-type.enum';
import { CreateBatchResponse } from '@/tsort/model/response/create-batch-response.model';
import { CreateBatchRequest } from '@/tsort/model/request/create-batch-request.model';
import { DeleteBatchEmptyTask } from '@/tsort/model/request/delete-batch-empty-task-request.model';
import { ResetLockRequest } from '@/tsort/model/request/reset-lock-request.model';
import { ResultResponse } from '@/common/model/response/general-response.model';
import FlashMessage from '@/common/components/flash-message.component';
import CommonUtil from '@/common/utils/common.util';
import MultiSortingModal from '../modal/multi-sorting/multi-sorting-modal.component';
import HandSortingModal from '../modal/hand-sorting/hand-sorting-modal.component';
import NoTaskMultiSortingModal from '../modal/no-task-sorting/no-task-multi-sorting-modal.component';
import { GoFlagOnWarnType } from '@/tsort/enum/go-flag-on-warn-type.enum';
import { ScanConfirmRequest } from '@/tsort/model/request/scan-confirm-request.model';
import { ScanConfirmResponse } from '@/tsort/model/response/scan-confirm-response.model';
import { ScanSystemMenuResponse } from '@/tsort/model/response/scan-system-menu-response.model';
import ErrorCdMsgConstants from '@/common/constants/error-cd-msg.constants';
import { GetTargetTaskRequest } from '@/tsort/model/request/get-target-task-request.model';
import ObjectUtils from '@/common/utils/object.util';
import { TrLogCategory } from '@/common/enum/tr-log-category.enum';
import MultiSortingComponent from '../task-sorting/multi-sorting/multi-sorting.component';
import AppConstants from '@/common/constants/app.constants';
import SwitchButtonComponent from '@/common/components/switch-button/switch-button.component';
import { ScanTarget } from '@/common/enum/scan-target.enum';
import { ScanSettingResponse } from '@/tsort/model/response/scan-setting-response.model';
import RouterUtils from '@/common/utils/router.util';
import LogMsgConstants from '@/common/constants/log-msg.constant';

const SettingStore = namespace(SettingStoreConst.SETTING_STORE_MODULE_NAME);
const SortStore = namespace(SortStoreConst.SORT_STORE_MODULE_NAME);

// constants for ScanConfirm Request HTTP
const CHUTEMODE = 0;

// 伝票スキャン
const ORDER_NO_MODE = 1;

const RFID_FIELD = 'RFID';
const ORDER_NO_FIELD = '伝票';
const BARCODE_FIELD = 'バーコード';
const ORDER_NUMBER_FIELD = '伝票コード';

export default abstract class BaseSortingComponent extends Vue {
  // ------------------ 抽象メソッド ------------------
  /**
   * 無効なスキャンコードフィールド名のエラーコードを取得します。
   *
   * @returns {string} エラーコード
   */
  protected abstract getErrCdInvalidScanCodeFieldName(): string;

  /**
   * エントリが過剰な場合のエラーコードを取得します。
   *
   * @returns {string} エラーコード
   */
  protected abstract getErrCdExcessEntry(): string;

  /**
   * エントリが過剰な場合のログメッセージを取得します。
   *
   * @returns {string} ログメッセージ
   */
  protected abstract getLogMsgExcessEntry(): string;

  /**
   * エラーメッセージを取得します。
   *
   * @param {number} maxInput - 入力値の最大許容値。省略可能です。
   * @returns {string} エラーメッセージ
   */
  protected abstract getErrMsgOverMaxInput(maxInput?: number): string;

  /**
   * 参照モーダルを取得します。
   *
   * @param {boolean} [callMethod=false] メソッドを呼び出すかどうかを指定します。デフォルトは false です。
   *
   * @returns {string} 参照モーダル
   */
  protected abstract getRefModal(callMethod?: boolean): string;

  /**
   * エラーを処理するためのメソッドです。
   */
  protected abstract handleCatchError(): void;

  /**
   * 作業指示を取得します。
   *
   * @returns {number} 作業指示
   */
  protected abstract getWorkInstruction(): number;

  /**
   * 無効な入力数量のエラーメッセージを取得します。
   *
   * @returns {string} エラーメッセージ
   */
  protected abstract getErrMsgInvalidInputQuantity(): string;
  // ----------------------抽象メソッドの終わり----------------------

  sortService = new SortingService();
  settingService = new SettingService();
  isProcessing = false;
  scanningError = false;
  targetTaskResponse = {} as GetTaskResponse;
  scanConfirmField = {} as ScanConfirmField;
  isOnFieldClick = false;
  inputQuantityStore: number[] = [];
  allowPutScanConfirm = true;
  fieldNameScanCode = '';
  isLoading = false;
  scanMode: ScanMode | null = null;
  trBatch: CreateBatchResponse | undefined;
  rfidCode = '';
  orderNumber = '';
  actualScanTimes = 0;
  checkRFID = '';
  $refs!: {
    multiSortingModal: MultiSortingModal;
    handSortingModal: HandSortingModal;
    multiSortingComponent: MultiSortingComponent;
    swipeButton: SwipeButton;
    noTaskMultiSortingModal: NoTaskMultiSortingModal;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  };

  /*Sort store*/
  @SortStore.Getter
  wesNo!: number;

  @SortStore.Getter
  lastChuteNo!: string;

  @SortStore.Getter
  rejectedTask!: boolean;

  @SortStore.Getter
  scanSystemSetting!: ScanSystemSetting | null;

  @SortStore.Getter
  scanSystemFields!: Array<ScanSystemField> | null;

  @SortStore.Getter
  taskTypeSorting!: TaskTypeSorting | null;

  @SortStore.Getter
  workTypeSorting!: WorkTypeSorting | null;

  @SortStore.Getter
  workInstruction!: WorkInstruction | null;

  @SortStore.Getter
  scanCancelTaskServiceSettingVisibleFlag!: boolean;

  @SortStore.Getter
  scanSetting!: ScanSettingResponse;

  @SortStore.Getter
  rfidModeScanTarget!: number;

  @SortStore.Getter
  orderNumberModeScanTarget!: number;

  @SortStore.Action
  updateWesNo!: (value: number) => void;

  @SortStore.Action
  updateLastChuteNo!: (value: string) => void;

  @SortStore.Action
  updateRejectedTask!: (value: boolean) => void;

  @SortStore.Action
  updateRFIDModeScanTarget!: (value: number) => void;

  @SortStore.Action
  updateOrderNumberModeScanTarget!: (value: number) => void;

  @SortStore.Action
  updateScanSetting!: (value: ScanSettingResponse) => void;

  @SortStore.Action
  updateScanSystemMenu!: (value: ScanSystemMenuResponse) => void;

  @SortStore.Action
  resetTaskTypeInfo!: () => void;

  // Setting store
  @SettingStore.Action
  updateChuteMode!: (value: number) => void;

  @SettingStore.Getter
  chuteMode!: ChuteModeType | undefined;

  @SettingStore.Getter
  externalDeviceId!: string;

  @SettingStore.Getter
  deviceType!: MstDeviceType;

  // Modal parameters
  isShow = false;
  typeSortModal!: SortModalType;
  titleModal!: string;

  // ------------------------ 共通のソート方法開始します ------------------------
  /**
   * フィールドとスワイプをリセットするメソッドです。
   */
  private resetFieldsAndSwipe(
    isCleanScanConfirmField = false,
    isFocusScanCodeField = false,
    isAutoHideModal = false
  ): void {
    if (!isAutoHideModal) {
      (this.$refs.swipeButton as SwipeButton)?.handleSuccess(!SortingUtils.isSingleSorting);
    } else {
      (this.$refs.swipeButton as SwipeButton)?.clearSwipeBtnResetTimeout();
      (this.$refs.swipeButton as SwipeButton)?.handleError(false);
    }
    if (isCleanScanConfirmField) {
      this.scanConfirmField = {
        ...(SortingUtils.isSingleSorting && { linkNumber: this.scanConfirmField.linkNumber })
      } as ScanConfirmField;
    }
    if (isFocusScanCodeField) {
      const scanCodeIndex = SortingUtils.getScanCodeFieldIndex(this.scanSystemFields);
      setTimeout(() => {
        (this.$refs[`input${scanCodeIndex}`] as HTMLInputElement)?.select();
      }, 150);
    }
  }

  /**
   * フィールドのクリックイベントを処理するメソッドです。
   *
   * @param {number} index インデックス
   */
  private onFieldsClickEvent(index: number) {
    if (!this.isOnFieldClick) {
      (this.$refs[`input${index}`] as HTMLInputElement)?.select();
      this.isOnFieldClick = true;
    }
  }

  /**
   * キーが押されたときに次の操作に移動するメソッドです。（伝票番号用）
   *
   * @param {KeyboardEvent} event キーボードイベント
   */
  private onKeyUpOrderNumberMoveNext(event: KeyboardEvent): void {
    if (SortingUtils.isSingleSorting && this.isLoading && ConfigUtils.isEnableLoadingMode()) {
      return;
    }
    if (event.key !== 'Enter') {
      if (this.orderNumber) {
        (this.$refs.swipeButton as SwipeButton)?.resetToStateToStart();
      } else {
        (this.$refs.swipeButton as SwipeButton)?.handleError(false);
      }
      this.changeStatusSwipeButtonOrderNumber();
      return;
    }

    // 複数回入力した場合、API呼び出しを1回処理します
    if (!SortingUtils.isSingleSorting && (this.isShow || this.isLoading)) {
      return;
    }

    this.handleModal(SortingUtils.isSingleSorting ? SortModalType.CONFIRM : SortModalType.SCAN);
  }

  /**
   * キーが押されたときに次の操作に移動するメソッドです。
   *
   * @param {KeyboardEvent} event キーボードイベント
   * @param {number} index インデックス
   */
  private onKeyUpMoveNext(event: KeyboardEvent, index: number): void {
    if (SortingUtils.isSingleSorting && this.isLoading && ConfigUtils.isEnableLoadingMode()) {
      return;
    }
    if (event.key !== 'Enter') {
      if (
        this.scanConfirmField.scanCode ||
        this.scanConfirmField.linkNumber ||
        this.scanConfirmField.expirationDate ||
        this.scanConfirmField.manufacturingLot ||
        this.scanConfirmField.reserve
      ) {
        (this.$refs.swipeButton as SwipeButton)?.resetToStateToStart();
      } else {
        (this.$refs.swipeButton as SwipeButton)?.handleError(false);
      }
      this.changeStatusSwipeButton();
      return;
    }

    // 複数回入力した場合、API呼び出しを1回処理します
    if (!SortingUtils.isSingleSorting && (this.isShow || this.isLoading)) {
      return;
    }

    const arrayLength = this.scanSystemFields?.filter((field) => field.fieldVisible === 1).length;
    (this.$refs[`input${index + 1}`] as HTMLInputElement)?.select();
    if (index + 1 == arrayLength) {
      this.handleModal(SortingUtils.isSingleSorting ? SortModalType.CONFIRM : SortModalType.SCAN);
    }
  }

  /**
   * スキャン確認を行います。
   *
   * @param {GoFlagOnWarnType} goFlagOnWarn 警告時の移動フラグタイプ
   * @param {number} [inputQuantity=1] 入力数量。デフォルトは1です。
   * @param {string} [chuteNo] シュート番号（オプション）
   */
  protected async putScanConfirm(goFlagOnWarn: GoFlagOnWarnType, inputQuantity = 1, chuteNo?: string): Promise<void> {
    try {
      this.isLoading = true;
      this.isProcessing = true;
      let processingScanConfirmField = this.scanConfirmField;
      if (this.isRFID) {
        processingScanConfirmField = { rfid: this.scanConfirmField.rfid } as ScanConfirmField;
      }
      if (this.isOrderNumber) {
        const dataResponse = await this.sortService.getScanSetting();
        if (dataResponse.orderNumberScanUse !== ORDER_NO_MODE) {
          await RouterUtils.replaceRouterName(AppConstants.NAME_TOP_PAGE);
          return;
        }
      }
      // APIを取得する
      const dataRequest = {
        workInstruction: this.getWorkInstruction(),
        workType: this.workTypeSorting,
        goFlagOnWarn: goFlagOnWarn,
        ...processingScanConfirmField,
        inputQty: inputQuantity,
        chuteMode: SortingUtils.isSingleSorting ? CHUTEMODE : this.chuteMode,
        externalDeviceId: this.externalDeviceId,
        externalDeviceType: this.deviceType,
        taskType: this.taskTypeSorting,
        ...(!SortingUtils.isSingleSorting && { chuteNo: chuteNo }),
        rejectSettingFlag: this.scanSystemSetting?.rejectFlag,
        lockGroup: this.scanSystemSetting?.lockGroup,
        rejectCreateNewTaskFlag: this.scanSystemSetting?.rejectCreateNewTaskFlag,
        rejectShowErrorFlag: this.scanSystemSetting?.rejectErrorShowFlag,
        rejectChuteNaShowErrorFlag: this.scanSystemSetting?.rejectChuteNaShowErrorFlag,
        orderNumber: this.orderNumber
      } as ScanConfirmRequest;
      const res = await this.sortService.putScanConfirm(dataRequest);
      if (!res) return;
      if (SortingUtils.isSingleSorting) {
        if ((res as ScanConfirmResponse)?.warnMsg) {
          this.titleModal = (res as ScanConfirmResponse)?.warnMsg;
          if (this.isRFID) {
            this.scanConfirmField.scanCode = (res as ScanConfirmResponse)?.scanCode;
          }
          this.showModal();
        } else {
          this.updateWesNo((res as ScanConfirmResponse).wesNo);
          this.updateLastChuteNo((res as ScanConfirmResponse).chuteId);
          if (!SortingUtils.isNoWorkInstruction) {
            this.updateRejectedTask((res as ScanConfirmResponse).rejectedTask);
          }
          FlashMessage.getInstance().showSuccessMessage('投入を実施しました。');
          CommonUtil.playSuccessSound();
          // isRFIDがtrueの場合、RFID のスキャンをリセットします
          if (this.isRFID) {
            (this.$refs['input0'] as HTMLInputElement)?.blur();
            setTimeout(() => {
              (this.$refs['input0'] as HTMLInputElement)?.focus();
            }, this.scanSetting?.rfidWaitTime);
            this.resetFieldsOfRFID();
            return;
          } else if (this.isOrderNumber) {
            this.resetFieldsOfOrderNumber();
          }
          this.resetFieldsAndSwipe(true, true);
        }
      } else {
        if (SortingUtils.isMultiSorting) {
          this.updateLastChuteNo((res as ScanConfirmResponse).chuteId);
        }
        this.$refs[this.getRefModal()].isFirstScan = false;
      }
    } finally {
      this.isLoading = false;
      if (SortingUtils.isMultiSorting) {
        this.allowPutScanConfirm = true;
      }
    }
  }

  /**
   * モーダルを処理します。
   *
   * @param {SortModalType} typeModal モーダルの種類
   */
  protected async handleModal(typeModal: SortModalType) {
    this.typeSortModal = typeModal;
    // データをモーダルに解析する
    if (SortingUtils.isSingleSorting && typeModal == SortModalType.CANCEL) {
      this.showModal();
      return;
    }
    this.fieldNameScanCode = SortingUtils.getScanCodeFieldName(this.scanSystemFields);
    if (!this.scanConfirmField.scanCode && !this.isRFID && !this.isOrderNumber) {
      const scanCodeIndex = SortingUtils.getScanCodeFieldIndex(this.scanSystemFields);
      this.handleEmptyFieldError(this.fieldNameScanCode, scanCodeIndex);
      return;
    } else if (this.isOrderNumber && !this.orderNumber) {
      this.handleEmptyFieldError(ORDER_NUMBER_FIELD, 0);
      return;
    }
    if (typeModal == SortModalType.CONFIRM) {
      // APIを呼び出してバッチを作成する
      try {
        if (SortingUtils.isNoTaskSingleSorting) {
          await this.postCreateBatch();
        }
        await this.putScanConfirm(GoFlagOnWarnType.OFF);
      } catch (error) {
        // TODO
        this.handleCatchError();
      }
      return;
    }
    if (typeModal == SortModalType.SCAN) {
      try {
        await this.putTargetTask(SortingUtils.isMultiSorting ? 0 : 1);
        (this.$refs.swipeButton as SwipeButton)?.handleSuccess(true);
        this.showModal();
      } catch (error) {
        (this.$refs.swipeButton as SwipeButton)?.handleError(true);
        // スキャン後、tryスコープでエラーが発生した場合にこの関数をトリガーします。
        await this.putResetLock(this.externalDeviceId, this.deviceType);
      }
    }
  }

  /**
   * 指定された主入力フィールドが空である場合にエラーメッセージを表示し。
   *
   * @param {string} fieldName 空である入力フィールドの名前で、エラーメッセージの表示に使用されます
   * @param {number | undefined} fieldIndex 入力フィールドのインデックス
   */
  private handleEmptyFieldError(fieldName: string, fieldIndex: number | undefined) {
    const errCd = this.getErrCdInvalidScanCodeFieldName();
    const errMsg = ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_INVALID_SCAN_CODE_FIELD_NAME_ERR_MSG;
    FlashMessage.getInstance().showErrorMsgWithErrorCode(errCd, errMsg, false, [fieldName]);
    CommonUtil.playErrorSound();
    (this.$refs.swipeButton as SwipeButton)?.handleSuccess(false);
    (this.$refs[`input${fieldIndex}`] as HTMLInputElement)?.select();
  }

  /**
   * モーダルを表示します。
   */
  private showModal() {
    this.isShow = true;
    if (this.isRFID) {
      return;
    }
    (this.$refs['input0'] as HTMLInputElement)?.select();
  }

  /**
   * モーダルを非表示にします。
   *
   * @param {boolean} isResetStateOfSwipeButton スワイプボタンの状態をリセットするかどうか
   * @param {boolean} [isSubmit=false] 送信するかどうか
   */
  protected hideModal(isResetStateOfSwipeButton: boolean, isSubmit = false) {
    if (!this.isShow) return;
    this.isShow = false;
    if (!SortingUtils.isSingleSorting) {
      this.isProcessing = false;
    }
    if (this.isRFID && !isSubmit) {
      setTimeout(() => {
        (this.$refs['input0'] as HTMLInputElement)?.select();
      }, 150);
    }
    (this.$refs.swipeButton as SwipeButton)?.handleSuccess(isResetStateOfSwipeButton);
  }

  /**
   * スワイプボタンの状態を変更します。
   */
  private changeStatusSwipeButton(): void {
    setTimeout(() => {
      if (
        this.scanConfirmField.scanCode ||
        this.scanConfirmField.linkNumber ||
        this.scanConfirmField.expirationDate ||
        this.scanConfirmField.manufacturingLot ||
        this.scanConfirmField.reserve
      ) {
        (this.$refs.swipeButton as SwipeButton)?.resetToStateToStart();
      } else {
        (this.$refs.swipeButton as SwipeButton)?.handleError(false);
      }
    }, 10);
  }

  /**
   * スワイプボタンの状態を変更します。伝票番号用)
   */
  private changeStatusSwipeButtonOrderNumber(): void {
    setTimeout(() => {
      if (this.orderNumber) {
        (this.$refs.swipeButton as SwipeButton)?.resetToStateToStart();
      } else {
        (this.$refs.swipeButton as SwipeButton)?.handleError(false);
      }
    }, 10);
  }

  /**
   * スキャン対象を切り替える非同期メソッドです。
   * @param {string} rfidModeScanTarget - 切り替えるスキャン対象
   */
  async switchRFIDModeScanTarget(rfidModeScanTarget: number): Promise<void> {
    if (rfidModeScanTarget === this.rfidModeScanTarget) {
      return;
    }

    await this.refreshScanSettings();

    if (rfidModeScanTarget === ScanTarget.RFID) {
      if (this.scanSetting.rfidMode) {
        this.updateRFIDModeScanTarget(rfidModeScanTarget);
      } else {
        await RouterUtils.replaceRouterName(AppConstants.NAME_TOP_PAGE);
        return;
      }
    } else if (rfidModeScanTarget === ScanTarget.BARCODE) {
      this.resetFieldsOfRFID();
      this.updateRFIDModeScanTarget(rfidModeScanTarget);
    }
    this.$nextTick(() => {
      (this.$refs.swipeButton as SwipeButton)?.handleError(false);
    });
    (this.$refs['input0'] as HTMLInputElement)?.focus();
    this.scanConfirmField = {} as ScanConfirmField;
    this.updateWesNo(0);
    this.updateLastChuteNo('');
    this.updateRejectedTask(false);
  }

  /**
   * スキャン対象を切り替える非同期メソッドです。（バーコード・伝票用）
   * @param {string} orderNumberModeScanTarget - 切り替えるスキャン対象
   */
  async switchOrderNumberModeScanTarget(orderNumberModeScanTarget: number): Promise<void> {
    if (orderNumberModeScanTarget === this.orderNumberModeScanTarget) {
      return;
    }

    await this.refreshScanSettings();

    if (orderNumberModeScanTarget === ScanTarget.ORDERNUMBER) {
      if (this.scanSetting.rfidMode === false && this.scanSetting.orderNumberScanUse === ORDER_NO_MODE) {
        this.resetFieldsOfOrderNumber();
        this.updateOrderNumberModeScanTarget(orderNumberModeScanTarget);
      } else {
        await RouterUtils.replaceRouterName(AppConstants.NAME_TOP_PAGE);
        return;
      }
    } else if (orderNumberModeScanTarget === ScanTarget.BARCODE) {
      this.resetFieldsOfOrderNumber();
      this.updateOrderNumberModeScanTarget(orderNumberModeScanTarget);
    }
    this.$nextTick(() => {
      (this.$refs.swipeButton as SwipeButton)?.handleError(false);
    });
    (this.$refs['input0'] as HTMLInputElement)?.focus();
    this.scanConfirmField = {} as ScanConfirmField;
    this.updateWesNo(0);
    this.updateLastChuteNo('');
    this.updateRejectedTask(false);
  }

  /**
   * スキャン設定を更新するプライベートメソッドです。
   */
  private async refreshScanSettings() {
    // API実行
    const listScanSystemMenuDataResponse = await this.sortService.getScanSystemField();
    const scanSystemMenuData = SortingUtils.filterListByCondition<ScanSystemMenuResponse>(
      listScanSystemMenuDataResponse,
      {
        taskType: this.taskTypeSorting,
        displayFlag: AppConstants.DISPLAY_FLAG_ON,
        workInstruction: this.workInstruction,
        workType: (workType: WorkTypeSorting) => workType !== WorkTypeSorting.MANUAL_SORTING
      }
    );

    // スキャンシステムフィールドの単一ソートインデックス
    const scanSystemFieldSingleSorting = SortingUtils.filterListByCondition<ScanSystemMenuResponse>(
      scanSystemMenuData,
      {
        workType: WorkTypeSorting.SINGLE_SORTING
      }
    );

    // 単一の並べ替えがない場合のアクション
    if (!scanSystemMenuData.length || !scanSystemFieldSingleSorting.length) {
      this.resetTaskTypeInfo();
      await RouterUtils.replaceRouterName(AppConstants.NAME_TOP_PAGE);
      return;
    }

    // ストレージ内のデータを更新する
    this.updateScanSystemMenu(scanSystemFieldSingleSorting[0]);

    // 単一の並べ替えモードのみが使用可能な場合はトグルを非表示にします
    if (scanSystemMenuData.length === 1) {
      this.$store.commit('setSwitchingBtnMode', false);
    } else if (scanSystemMenuData.length === 2) {
      // 単一ソートと複数ソートの両方が使用可能な場合にトグル ボタンを表示する
      this.$store.commit('setSwitchingBtnMode', true);
    }

    const dataResponse = await this.sortService.getScanSetting();
    this.updateScanSetting(dataResponse);
    FlashMessage.getInstance().hideAllMessages();
  }

  /**
   * RFID コードの貼り付けイベントを処理するプライベートメソッドです。
   * @param {ClipboardEvent} event - クリップボードイベント
   */
  private onPasteRFIDCode(event: ClipboardEvent) {
    event.preventDefault();

    // RFIDコードを取得
    const inputValue = event.clipboardData?.getData('text') || '';

    // inputValueがscanSettingで定義されたrfidDelimiterCodeと一致するかを確認します。
    if (inputValue === this.scanSetting?.rfidDelimiterCode) {
      // スキャン回数が0の場合は、rfidCodeにinputValueを代入します。
      // そうでない場合は、rfidCodeにinputValueを追加します。
      this.rfidCode = this.actualScanTimes === 0 ? inputValue : this.rfidCode + inputValue;
      this.scanRFIDNoItem();
      return;
    }

    if (!this.getLastRFIDCode(inputValue)) {
      this.rfidCode += inputValue;
      return;
    }

    // RFIDコードを設定
    if (this.actualScanTimes === 0) {
      this.rfidCode = inputValue;
      this.checkRFID = this.rfidCode;
    } else {
      this.rfidCode += inputValue;
    }
    this.actualScanTimes++;

    // 区切り文字が2つ連続している場合、または入力値が区切り文字の場合、処理を終了します
    if (this.actualScanTimes > 1 && this.getLastRFIDCode(this.rfidCode) !== this.checkRFID) {
      this.nonMatchRFIDCode();
      return;
    }

    // スキャン確認のRFIDを設定するプライベートメソッドです
    this.putScanConfirmRFID();
  }

  /**
   * 入力区切り文字の処理を行うメソッドです。
   * @param {KeyboardEvent} event - キーボードイベント
   */
  private onInputDelimeter(event: KeyboardEvent) {
    // 区切り文字以外のキーが押された場合、処理を終了します
    if (event.key !== this.scanSetting.rfidDelimiterCode) {
      return;
    } else if (!this.getLastRFIDCode(this.rfidCode)) {
      this.scanRFIDNoItem();
      return;
    }

    // RFIDコードを設定
    if (this.actualScanTimes === 0) {
      this.checkRFID = this.rfidCode;
    }
    this.actualScanTimes++;

    // 区切り文字が2つ連続している場合、または入力値が区切り文字の場合、処理を終了します
    if (this.actualScanTimes > 1 && this.checkRFID !== this.getLastRFIDCode(this.rfidCode)) {
      this.nonMatchRFIDCode();
      return;
    }

    // スキャン確認のRFIDを設定するプライベートメソッドです
    this.putScanConfirmRFID();
  }

  /**
   * スキャン確認のRFIDを設定するプライベートメソッドです。
   */
  private putScanConfirmRFID(): void {
    if (this.actualScanTimes === this.scanSetting?.rfidScanTimes) {
      this.$refs['input0']?.blur();
      this.scanConfirmField.rfid = this.checkRFID.slice(0, this.checkRFID.length - 1);
      this.handleModal(SortModalType.CONFIRM);
    }
  }

  /**
   * RFID コードが一致しない場合に呼び出されるプライベートメソッドです。
   */
  private nonMatchRFIDCode(): void {
    (this.$refs['input0'] as HTMLInputElement).focus();
    const errCd = ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_NON_MATCH_RFID_SINGLE_SORT_ERR_CD;
    const logMsgParamList = [errCd, this.rfidCode];
    this.sortService.addLogWarn(
      logMsgParamList,
      LogMsgConstants.FUNC_SCAN_CONFIRM_NON_MATCH_RFID_SINGLE_SORT_LOG_MSG,
      TrLogCategory.RFID_SCANNING
    );
    FlashMessage.getInstance().showErrorMsgWithErrorCode(
      errCd,
      ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_NON_MATCH_RFID_SINGLE_SORT_ERR_MSG
    );
    CommonUtil.playErrorSound();
    this.updateRFIDCode();
  }

  /**
   * RFID コードを再割り当てするプライベートメソッドです。
   */
  private updateRFIDCode(): void {
    this.rfidCode = this.getLastRFIDCode(this.rfidCode);
    this.actualScanTimes = 1;
    this.checkRFID = this.rfidCode;
  }

  /**
   * 最後に読み取られたRFIDコードを取得します。
   * @param {string} value - RFIDコード
   * @returns 最後に読み取られたRFIDコード。RFIDコードが見つからない場合は`null`を返します。
   */
  private getLastRFIDCode(value: string): string {
    const delimiterCode = this.scanSetting?.rfidDelimiterCode;
    const REGEX_LAST_RFID_CODE = new RegExp(`([^${delimiterCode}]+)\\${delimiterCode}$`);
    return value.match(REGEX_LAST_RFID_CODE)?.[0] || '';
  }

  /**
   * RFIDをスキャンし、アイテムが見つからない場合の処理を行います。
   */
  private scanRFIDNoItem(): void {
    const errCd = this.getErrCdInvalidScanCodeFieldName();
    const errMsg = ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_INVALID_SCAN_CODE_FIELD_NAME_ERR_MSG;
    FlashMessage.getInstance().showErrorMsgWithErrorCode(errCd, errMsg, false, [RFID_FIELD]);
    this.scanFailed();
  }

  /**
   * スクロール可能なスキャンフィールドを取得するための getter メソッドです。
   */
  protected get scrollScanFields() {
    return (
      <div class="scroll-scan-field">
        {this.getSwitchingBtn}
        {this.getBarcodeOrderNumberSwitchingBtn}
        <div
          class={[
            'd-flex flex-column align-items-center w-100 pt-1',
            {
              'justify-content-center':
                !this.isParallelSingleSortingAndRFID && !this.isVisibleBarCodeAndOrderNumberToggle,
              'overflow-auto pb-2': this.isParallelSingleSortingAndRFID || this.isVisibleBarCodeAndOrderNumberToggle
            }
          ]}
        >
          {this.isRFID ? (
            this.getRFIDInput
          ) : this.isEnabledOrderNumber === true ? (
            this.getOrderNumberInput
          ) : (
            <div v-frag>
              <h4 class="text-center font-weight-bold pb-4">スキャンしてください</h4>
              {this.scanSystemFields
                ?.filter((field) => field.fieldVisible === 1)
                .map((field, index) => {
                  return (
                    <div class="row w-50 align-items-center mb-3">
                      <div class="col-4">
                        <h5 class="text-left font-weight-bold text-break">{field.fieldName}</h5>
                      </div>
                      <div class="col-8">
                        <b-input
                          ref={`input${index}`}
                          size="md"
                          autofocus={index === 0 ? true : false}
                          vModel={this.scanConfirmField[field.fieldId as keyof ScanConfirmField]}
                          vOn:keyup_prevent={(event: KeyboardEvent) => this.onKeyUpMoveNext(event, index)}
                          onPaste={() => this.changeStatusSwipeButton()}
                          onClick={() => this.onFieldsClickEvent(index)}
                          onBlur={() => (this.isOnFieldClick = false)}
                          readonly={this.isLoading || this.isShow}
                        ></b-input>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      </div>
    );
  }

  /**
   * スイッチングボタンを取得するメソッドです。
   * @returns {HTMLElement} スイッチングボタン要素
   */
  private get getSwitchingBtn() {
    return (
      this.isParallelSingleSortingAndRFID && (
        <div class="pt-3 pr-3">
          <SwitchButtonComponent
            title="スキャン対象"
            leftLabel={RFID_FIELD}
            leftValue={ScanTarget.RFID}
            rightLabel={BARCODE_FIELD}
            rightValue={ScanTarget.BARCODE}
            active={this.isRFID}
            slider={true}
            on-change={(targetValue: number) => this.switchRFIDModeScanTarget(targetValue)}
          />
        </div>
      )
    );
  }

  /**
   * RFID入力を取得するメソッドです。
   * @returns {HTMLElement} RFID入力要素
   */
  private get getRFIDInput() {
    return (
      <div v-frag>
        <h4 class="text-center font-weight-bold pb-4">RFID読取機器にかざしてください</h4>
        <div class="row w-75 align-items-center mb-3">
          <div class="col-1">
            <h5 class="text-left font-weight-bold">{RFID_FIELD}</h5>
          </div>
          <div class="col-11">
            <b-input
              onPaste={(event: ClipboardEvent) => this.onPasteRFIDCode(event)}
              vModel={this.rfidCode}
              vOn:keyup_prevent={(event: KeyboardEvent) => this.onInputDelimeter(event)}
              autofocus={true}
              type="text"
              ref="input0"
              size="lg"
            />
          </div>
        </div>
      </div>
    );
  }

  /**
   * バーコード・伝票スイッチングボタンを取得するメソッドです。
   * @returns {HTMLElement} スイッチングボタン要素
   */
  private get getBarcodeOrderNumberSwitchingBtn() {
    return (
      this.isVisibleBarCodeAndOrderNumberToggle && (
        <div class="pt-3 pr-3">
          <SwitchButtonComponent
            title="スキャン対象"
            leftLabel={BARCODE_FIELD}
            leftValue={ScanTarget.BARCODE}
            rightLabel={ORDER_NO_FIELD}
            rightValue={ScanTarget.ORDERNUMBER}
            active={!this.isOrderNumber}
            slider={true}
            on-change={(targetValue: number) => this.switchOrderNumberModeScanTarget(targetValue)}
          />
        </div>
      )
    );
  }

  /**
   * 伝票番号を取得するメソッドです。
   * @returns {HTMLElement} 伝票番号入力要素
   */
  private get getOrderNumberInput() {
    return (
      <div v-frag>
        <h4 class="text-center font-weight-bold pb-4">スキャンしてください</h4>
        <div class="row w-50 align-items-center mb-3">
          <div class="col-4">
            <h5 class="text-left font-weight-bold">{ORDER_NUMBER_FIELD}</h5>
          </div>
          <div class="col-8">
            <b-input
              ref="input0"
              size="md"
              autofocus={true}
              vModel={this.orderNumber}
              vOn:keyup_prevent={(event: KeyboardEvent) => this.onKeyUpOrderNumberMoveNext(event)}
              onPaste={() => this.changeStatusSwipeButtonOrderNumber()}
              onClick={() => this.onFieldsClickEvent(0)}
              onBlur={() => (this.isOnFieldClick = false)}
            />
          </div>
        </div>
      </div>
    );
  }

  /**
   * スキャンが失敗したことを処理します。
   */
  protected scanFailed(): void {
    CommonUtil.playErrorSound();
    this.$nextTick(() => {
      (this.$refs['input0'] as HTMLInputElement)?.select();
    });
    if (this.isRFID) {
      this.resetFieldsOfRFID(true);
      return;
    }
    (this.$refs.swipeButton as SwipeButton)?.handleError(true);
  }

  /**
   * 並列単一ソーティングとRFIDが有効かどうかを取得するゲッタープロパティです。
   * @returns {boolean} 並列単一ソーティングとRFIDが有効な場合はtrue、それ以外の場合はfalse
   */
  private get isParallelSingleSortingAndRFID(): boolean {
    return SortingUtils.isParallelSingleSorting && this.scanSetting.rfidMode;
  }

  /**
   * バーコード・伝票スキャン切り替えトグルの表示条件を満たしているか取得するゲッタープロパティです。
   * @returns {boolean} バーコード・伝票スキャン切り替えトグルの表示条件を満たしている場合はtrue、それ以外の場合はfalse
   */
  private get isVisibleBarCodeAndOrderNumberToggle(): boolean {
    return (
      SortingUtils.isParallelSingleSorting &&
      !this.scanSetting.rfidMode &&
      this.scanSetting.orderNumberScanUse === ORDER_NO_MODE
    );
  }

  /**
   * RFIDが有効かどうかを取得するゲッタープロパティです。
   * @returns {boolean} RFIDが有効な場合はtrue、それ以外の場合はfalse
   */
  protected get isRFID(): boolean {
    return this.isParallelSingleSortingAndRFID && this.rfidModeScanTarget === ScanTarget.RFID;
  }

  /**
   * 伝票スキャンが有効かどうかを取得するゲッタープロパティです。
   * @returns {boolean} 伝票スキャンが有効な場合はtrue、それ以外の場合はfalse
   */
  protected get isOrderNumber(): boolean {
    return this.isVisibleBarCodeAndOrderNumberToggle && this.orderNumberModeScanTarget === ScanTarget.ORDERNUMBER;
  }

  /**
   * 伝票番号のスキャンエリアの表示・非表示を取得するゲッタープロパティです。
   * @returns {boolean} 表示する場合はtrue、それ以外の場合はfalse
   */
  protected get isEnabledOrderNumber(): boolean {
    return (
      SortingUtils.isSingleSorting &&
      !this.isRFID &&
      this.isOrderNumber &&
      this.scanSetting.orderNumberScanUse === ORDER_NO_MODE &&
      SortingUtils.workInstruction !== 0
    );
  }

  /**
   * フィールドをリセットするメソッドです。
   * @param scanFailed スキャンが失敗したかどうか。デフォルトはfalseです
   */
  private resetFieldsOfRFID(scanFailed = false): void {
    if (!scanFailed) {
      this.rfidCode = '';
    }
    this.actualScanTimes = 0;
    this.checkRFID = '';
  }

  /**
   * フィールドをリセットするメソッドです。
   * @param scanFailed スキャンが失敗したかどうか。デフォルトはfalseです
   */
  private resetFieldsOfOrderNumber(scanFailed = false): void {
    this.resetFieldsAndSwipe(true);
    if (!scanFailed) {
      this.orderNumber = '';
    }
  }

  // ------------------------ 共通のソート方法の終わり ------------------------

  // ------------------ 共通のisNotSingleSortingメソッドを開始します ------------------
  /**
   * APIからスキャンモードを取得し、スキャンモードを検出します。
   */
  protected async getScanMode(): Promise<void> {
    const { scanMode } = await this.settingService.getScanMode();
    this.scanMode = scanMode;
  }

  /**
   * 入力数量を格納するメソッドです。
   *
   * @param {number} value 格納する値
   */
  private storeInputQuantity(value: number) {
    if (this.inputQuantityStore.length === 0) {
      this.inputQuantityStore.push(value);
    } else if (!this.checkTheSameInputQuantity(value)) {
      this.inputQuantityStore = [];
      this.inputQuantityStore.push(value);
    }
  }

  /**
   * 同じ入力数量かどうかをチェックするメソッドです。
   *
   * @param {number} value チェックする値
   */
  private checkTheSameInputQuantity(value: number): boolean {
    return this.inputQuantityStore.includes(value);
  }

  /**
   * 終了ボタンの処理を行うメソッドです。
   */
  protected async exitBtnHandle() {
    this.resetFieldsAndSwipe();
    if (this.isProcessing) {
      this.hideModal(false);
    } else {
      this.hideModal(true);
    }

    await this.putResetLock(this.externalDeviceId, this.deviceType);
    // リセット
    this.inputQuantityStore = [];
  }

  /**
   * ロックをリセットする非同期のメソッドです。
   *
   * @param {string} externalDeviceId 外部デバイスID
   * @param {MstDeviceType} deviceType デバイスの種類
   */
  private async putResetLock(externalDeviceId: string, deviceType: MstDeviceType): Promise<ResultResponse | null> {
    // タスクのないマルチソートの場合、ロックをリセットしません
    if (SortingUtils.isNoTaskMultiSorting) {
      return null;
    }
    // リセットロックのリクエストを作成します
    let dataRequest = {} as ResetLockRequest;
    dataRequest = {
      externalDeviceId: externalDeviceId,
      externalDeviceType: deviceType
    };
    return await this.sortService.putResetLock(dataRequest);
  }

  /**
   * ユーザー入力値をチェックする。
   *
   * @return {boolean} 入力数量が 1 ～ 999 の数値の場合は true、それ以外の場合は false
   */
  private validateInputQuantity(inputQuantity: string, maxInputQuantity: number): boolean {
    if (!inputQuantity.trim()) {
      FlashMessage.getInstance().showErrorMessage('投入数は必須です。');
      CommonUtil.playErrorSound();
      return false;
    }
    let errorMsg = '';
    const inputQuantityNum = Number(inputQuantity);
    if (!inputQuantityNum || inputQuantityNum < 1) {
      errorMsg = this.getErrMsgInvalidInputQuantity();
    } else if (this.scanMode === ScanMode.ONE_HUNDRED_PERCENT_SCAN) {
      if (inputQuantityNum > AppConstants.QUANTITY_MAX_VALUE) {
        errorMsg = this.getErrMsgOverMaxInput(AppConstants.QUANTITY_MAX_VALUE);
      }
    } else if (inputQuantityNum > maxInputQuantity) {
      if (!this.$refs[this.getRefModal()].isInputQtyExceedLimits()) {
        errorMsg = this.getErrMsgOverMaxInput(maxInputQuantity);
      }
    }
    if (errorMsg) {
      FlashMessage.getInstance().showErrorMessage(errorMsg);
      CommonUtil.playErrorSound();
      return false;
    }
    return true;
  }

  // APIを呼び出す
  /**
   * ターゲットタスクを更新する非同期のメソッドです。
   *
   * @param {number} inputQuantity 入力数量
   */
  private async putTargetTask(inputQuantity: number): Promise<void> {
    try {
      this.isLoading = true;
      const dataRequest = {
        workType: this.workTypeSorting,
        workInstruction: this.getWorkInstruction(),
        ...this.scanConfirmField,
        inputQty: inputQuantity,
        chuteMode: this.chuteMode,
        externalDeviceId: this.externalDeviceId,
        externalDeviceType: this.deviceType,
        taskType: this.taskTypeSorting,
        lockGroup: this.scanSystemSetting?.lockGroup || ''
      } as GetTargetTaskRequest;
      const res = await this.sortService.putGetTargetTask(dataRequest).catch((er) => {
        this.scanFailed();
        return Promise.reject(er);
      });
      if (!res) {
        return Promise.reject();
      }

      // 残り数量が0またはnullのアイテムを持つシュートを、targetTaskListから削除します。
      const availableTargetTask = this.filterTargetTask(res as GetTaskResponse);
      // 空のリストであり、かつモーダルがまだ開かれていない場合に拒否します。
      if (
        !SortingUtils.isNoTaskMultiSorting &&
        availableTargetTask?.displayTasks?.length <= 0 &&
        this.isShow == false
      ) {
        const scanCodeCutout = availableTargetTask.scanCodeCutout ?? '';
        const logMsgParamList = [
          this.getErrCdExcessEntry(),
          scanCodeCutout,
          ObjectUtils.objectToStringForLogRegistry<GetTargetTaskRequest>(dataRequest)
        ];
        try {
          await this.sortService.addLogWarn(logMsgParamList, this.getLogMsgExcessEntry(), TrLogCategory.EXCESS_INPUT);
        } finally {
          FlashMessage.getInstance().showErrorMsgWithErrorCode(
            this.getErrCdExcessEntry(),
            ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_TASK_EXCESS_ENTRY_ERR_MSG
          );
          CommonUtil.playErrorSound();
          (this.$refs['input0'] as HTMLInputElement)?.select();
        }
        return Promise.reject();
      }

      if (availableTargetTask?.displayTasks?.length <= 0) {
        this.isShow = false;
        await this.putResetLock(this.externalDeviceId, this.deviceType);
        FlashMessage.getInstance().showSuccessMessage('投入を実施しました。', true);
        // すべての項目が並べ替えられた場合は、すべてのフィールドをクリアします。
        this.resetFieldsAndSwipe(true, false, true);
      } else {
        // targetTaskListの変更を反映します
        this.targetTaskResponse = availableTargetTask;
        if (this.isShow) {
          FlashMessage.getInstance().showSuccessMessage('投入を実施しました。');
        }
      }
      CommonUtil.playSuccessSound();
      return Promise.resolve();
    } finally {
      this.isLoading = false;
    }
  }

  /**
   * 受け入れボタンの処理を行う非同期のメソッドです。
   *
   * @param {Object} scanConfirmPacket スキャン確認パケット
   * @param {string} scanConfirmPacket.inputQuantity 入力数量
   * @param {string} scanConfirmPacket.chuteNo シュート番号
   */
  protected async acceptBtnHandle(scanConfirmPacket: {
    inputQuantity: string;
    chuteNo: string;
    maxInputQuantity: number;
  }) {
    if (this.isLoading && ConfigUtils.isEnableLoadingMode()) {
      return;
    }
    // リセットステータス
    this.scanningError = false;
    const { inputQuantity, chuteNo, maxInputQuantity } = scanConfirmPacket;
    let inputQuantityNum = 0;
    if (!this.validateInputQuantity(inputQuantity, maxInputQuantity)) {
      return;
    }
    inputQuantityNum = parseInt(inputQuantity, 10);
    try {
      if (SortingUtils.isNoTaskMultiSorting) {
        await this.postCreateBatch();
      }
      await this.putScanConfirm(GoFlagOnWarnType.OFF, inputQuantityNum, chuteNo);
      if (!this.scanningError) {
        await this.putTargetTask(inputQuantityNum);
        this.storeInputQuantity(inputQuantityNum);
        // 変更された数量の警告メッセージを表示し、サウンドを再生するメソッドです
        if (SortingUtils.isMultiSorting) {
          this.getRefModal(true);
        }
      }
      this.$refs[this.getRefModal()].isScanningError = this.scanningError;
    } catch (error) {
      if (SortingUtils.isNoTaskMultiSorting) {
        this.deleteBatchEmptyTask();
      }
      CommonUtil.playErrorSound();
      this.scanningError = true;
    }
  }

  /**
   * ターゲットタスクをフィルタリングするメソッドです。
   *
   * @param {GetTaskResponse} task タスク
   * @returns {boolean} タスクが対象かどうか
   */
  private filterTargetTask(task: GetTaskResponse): GetTaskResponse {
    if (SortingUtils.isNoTaskMultiSorting) return task;
    const filterTargetTask = task?.displayTasks.filter((task) => task.remainingQty > 0);
    task.displayTasks = filterTargetTask;
    return task;
  }
  // ------------------ 共通のisNotSingleSortingメソッドの終了 ------------------

  // ------------------ 共通のisNoTaskSortingメソッドを開始します ------------------
  /**
   * バッチを作成する非同期のメソッドです。
   */
  private async postCreateBatch(): Promise<void> {
    const dataRequest = {
      taskType: this.taskTypeSorting,
      workType: this.workTypeSorting
    } as CreateBatchRequest;
    const dataResponse = await this.sortService.postCreateBatch(dataRequest);
    this.trBatch = dataResponse;
  }

  /**
   * 空のタスクを含むバッチを削除します。
   */
  protected deleteBatchEmptyTask() {
    if (this.trBatch && this.trBatch.trBatch) {
      const deleteBatchEmptyTask = {
        batchNo: this.trBatch.trBatch.batchNo,
        batchDetailNo: this.trBatch.trBatch.batchDetailNo
      } as DeleteBatchEmptyTask;
      this.sortService.deleteBatchEmptyTask(deleteBatchEmptyTask);
    }
  }
  // ------------------ 共通のisNoTaskSortingメソッドの終了 ------------------
}
